import {Outlet} from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className={'flex items-center justify-center w-full h-screen'}>
      <div className={'flex flex-col justify-center items-center bg-white w-full col-span-2 h-full'}>
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
